export const tableStyles = {
    maxHeight: '300px'
  };
